import { render, staticRenderFns } from "./ProjectRiskManageForm.vue?vue&type=template&id=137eb898&"
import script from "./ProjectRiskManageForm.vue?vue&type=script&lang=js&"
export * from "./ProjectRiskManageForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRiskManageForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports